import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/src/components/Layout.js";
import { Link } from 'gatsby';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1>{`Workshop de Gatsby`}</h1>
    <p>{`En este workshop, vamos a aprender y entender las bases de Gatsby haciendo un
portfolio para mostrar los proyectos que tengas subidos a tu Github. Y si te
animás, también te enseño a hacerte un blog propio para escribir sobre lo que
quieras!`}</p>
    <p>{`Si estás haciendo este workshop en tu casa, podés ver antes de empezar la
presentación que tiene info bastante útil sobre la estructura de archivos y
carpetas de Gatsby. Igual son temas que se van a ver en la Intro de este
workshop.`}</p>
    <p><a parentName="p" {...{
        "href": "https://docs.google.com/presentation/d/1pcCvCoAoxqXqXMYqlw7mj820_sqTrGFZKa62D-o06jQ/edit?usp=sharing"
      }}>{`Click para ver la presentación 🍸`}</a></p>
    <p>{`Antes que seguir con todo, definamos Gatsby: Es un framework de React, una capa
que va por encima de React que genera sitios estáticos (HTML + CSS + JS).`}</p>
    <p>{`Ahora sí, si queremos empezar con Gatsby, tenemos que saber que nos facilita
algunas cosas que, si las queremos implementar nosotros, son complejas, como por
ejemplo:`}</p>
    <ul>
      <li parentName="ul">{`Routing`}</li>
      <li parentName="ul">{`Lazy loading en las imágenes`}</li>
      <li parentName="ul">{`GraphQL`}</li>
      <li parentName="ul">{`Server Side Rendering o SSR`}</li>
      <li parentName="ul">{`PWA (Progressive Web App)`}</li>
    </ul>
    <p>{`Todo eso viene "gratis" y preconfigurado (para tener una PWA con sólo
descomentar una línea ya está, `}<strong parentName="p">{`en serio`}</strong>{`). Vamos a estar viendo los primeros
3 en este workshop.`}</p>
    <p>{`Gatsby además tiene un sistema de plugins que la rompe, y documentación
completísima, y mucho material, e integración con muchas plataformas, y y y y y
y y se nota que me gusta `}<strong parentName="p">{`mucho`}</strong>{`?`}</p>
    <p><strong parentName="p">{`Navegación por el workshop:`}</strong>{` Como verán si van para abajo de todo, hay
botones para ir al próximo paso, para hacer las cosas en orden. Si ya están
avanzados tienen a la izquierda el menú (o en un botón arriba si están viendo
esto en mobile).`}</p>
    <p>{`Y este es un temario con lo que vamos a ver en cada paso del workshop:`}</p>
    <ol>
      <li parentName="ol">
        <Link to="/intro" mdxType="Link">Intro</Link>: Comenzando un proyecto, partes de un proyecto
en Gatsby, Routing y Lazy loading de imágenes.
      </li>
      <li parentName="ol">
        <Link to="/plugins" mdxType="Link">Plugins</Link>: Tipos de plugins en Gatsby, cómo utilizarlos.
      </li>
      <li parentName="ol">
        <Link to="/paso-01" mdxType="Link">Workshop - Paso 1</Link>: Creando un token de Github, definiendo 
nuestra query de GraphQL, instalando y configurando plugin.
      </li>
      <li parentName="ol">
        <Link to="/graphql" mdxType="Link">GraphQL</Link>: Qué es GraphQL, diferencias con una API REST, GraphiQL.
      </li>
      <li parentName="ol">
        <Link to="/paso-02" mdxType="Link">Workshop - Paso 2</Link>: Haciendo la query para el plugin de Github, 
manejo en frontend de nuestra data, deploy de nuestro portfolio en Netlify.
      </li>
      <li parentName="ol">
        <Link to="/paso-03" mdxType="Link">Workshop - Paso 3</Link>: Creando nuestro blog.
      </li>
    </ol>
    <hr></hr>
    <h2>{`Créditos`}</h2>
    <p>{`Fuentes usadas para hacer este workshop:`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.gatsbyjs.org"
        }}>{`Documentación de Gatsby`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/atomiks/tippyjs/tree/master/website"
        }}>{`Documentación de Tippy.js usada como plantilla de Gatsby+MDX`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      